/**
 * X's `data` for one promoted tweet, as X sent it (A3, audits/2026-10-22/a3-raw-spec.md, rev. 1).
 *
 * «X sends no reason through the API» stands on X's reference alone: no body X sent for a
 * REJECTED promoted tweet had been read, because the worker keeps seven fields of it. The
 * worker's `?raw=1` passes the whole `data` on, and this shows it — as text in a `<pre>`,
 * never as markup, and with nothing picked out of it. X's envelope around `data` (`request`)
 * is not passed, so the words say `data` and promise nothing wider. If a reason is ever seen
 * there, it is mapped in its own change, from that observation.
 */

export const RAW_ANSWER_BUTTON = "Show X's data for this ad";

/** Says what the text is, and promises nothing about what it contains. */
export const RAW_ANSWER_NOTE =
	"X's `data` for this ad, as X sent it — the console maps nothing from it.";

/** Offered where X's review refused the creative — the answer A3 wants to observe. */
export function offersRawAnswer(approvalStatus: string | null): boolean {
	return approvalStatus === "REJECTED";
}

/** The object as JSON text, every field kept. */
export function rawAnswerText(raw: unknown): string {
	return JSON.stringify(raw, null, 2);
}
